import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  CustomizeLabelAndMarkerModalContainer, type CustomizeLabelAndMarkerModalContainerProps,
} from './customizeLabelAndMarkerModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    LabelAndMarkerSettings: CustomizeLabelAndMarkerModalContainerProps;
  }
}

modalRenderer.register('LabelAndMarkerSettings', CustomizeLabelAndMarkerModalContainer);
